import useApiHelpers from "@/composables/api/helpers";

const { postRequest } = useApiHelpers();

export default function useLoggingEndpoint() {
  /**
   *
   * @param {object} loggingData
   * @param {function} successCallback
   * @param {function} failureCallback
   */
  const logInfoOnServer = (
    loggingData,
    successCallback = () => {},
    failureCallback = () => {},
  ) => postRequest(
      '/logging/log',
      {
        data: loggingData,
      },
      successCallback,
      failureCallback,
    );

  return {
    logInfoOnServer,
  };
}
